/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getOneDirectionForAllDefinitionsEarlyRequestRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getOneDirectionForAllDefinitions',
  auth: 'app',
  fingerprint: 'CbzSzFnq3ulKSdlMBfjVt5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getDefinitionsFromObjectTypeEarlyRequestRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getDefinitionsFromObjectType',
  auth: 'app',
  fingerprint: 'cNMZK374kTNKSdlMBfjVt5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getAllBaseUnlabeledDefinitionsEarlyRequestRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getAllBaseUnlabeledDefinitions',
  auth: 'app',
  fingerprint: 'fMdfrxfw-wRKSdlMBfjVt5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};